export default __webpack_public_path__ + "static/media/coopimg.0d986f62.jpeg";